<div class="inner">
  <div class="info">
    <h1 class="title">{{ title }}</h1>

    <quant-tooltip [content]="'call.SESSION_ID_COPIED' | transloco" arrow="top">
        <button class="sessionId" (click)="handleSessionIdClick()">
        <qai-icon kind="copy" size="16px" />
        <span class="label">{{'call.COPY_SESSION_ID_BUTTON' | transloco}}</span>
      </button>
    </quant-tooltip>
  </div>

  <div class="controls">
    <ng-content select="app-call-controls, app-visual-aid-call-controls" />
  </div>
</div>
